import type {ExpenseBatchStatus} from '@api';

export const PENDING_EXPENSE_GROUP_ID = 'pending';

export type FormattedExpenseBatchGroup = {
    id: string;
    status: ExpenseBatchStatus;
    createdDate: string;
    rawCreatedDate?: Date;
    total: string;
    invoiceExpenseId?: string;
};

export type FormattedExpenseBatchRow = {
    id: string;
    groupId: string;
    batch: FormattedExpenseBatchGroup;
    expanded: boolean;
};
